import apiClient from './apiClient';
import type { ComunePublicConfig } from '../config/comuneConfig';

export const comuneConfigService = {
  async getPublicConfig(): Promise<ComunePublicConfig> {
    const res = await apiClient.get<ComunePublicConfig>('/api/config/public');
    const data = res.data as unknown;
    // Guard against a non-JSON response (e.g. the SPA index.html served by a
    // misrouted /api path): fail loudly so ConfigContext shows the error UI
    // instead of passing a malformed object on to the app (white screen).
    if (
      !data ||
      typeof data !== 'object' ||
      typeof (data as ComunePublicConfig).features !== 'object'
    ) {
      throw new Error(
        `Risposta /api/config/public inattesa: l'API potrebbe non essere raggiungibile ` +
          `(baseURL=${apiClient.defaults.baseURL}).`,
      );
    }
    return res.data;
  },
};
